export const getHeaderStyle = (errorState) => {
	return {
		backgroundColor: errorState ? '#f44336' : '#5cb860',
		color: '#fff',
		fontWeight: 400,
		padding: '5px 10px',
		margin: '15px 0 0 0',
		borderRadius: '5px',
	};
};

const headerStyle = {
	color: '#fff',
	fontWeight: '400',
	textAlign: 'center',
	padding: '5px 0',
	margin: '15px 0 0 0',
	borderRadius: '5px',
};

export const headerStyleNoMeasurements = {
	backgroundColor: '#ffa21a',
	color: '#fff',
	fontWeight: '400',
	textAlign: 'center',
	padding: '5px 10px',
	margin: '10px 0 0 0',
	borderRadius: '5px',
	fontSize: '16px',
	opacity: '1',
};

export const emptyHeaderStyle = { margin: '24px 0 0 0', height: '20px' };

export const headerStyleFail = { ...headerStyle, backgroundColor: '#f44336' };
export const headerStyleSuccess = { ...headerStyle, backgroundColor: '#5cb860' };

export const sweetAlertStyle = {
	display: 'block',
	marginTop: '-150px',
	margin: '150px auto 0 auto',
	overflow: 'visible',
	width: '476px',
	maxWidth: '95%',
	top: '0',
	left: '0',
	right: '0',
};

export const sweetAlertBigStyle = {
	display: 'block',
	marginTop: '-150px',
	margin: '150px auto 0 auto',
	overflow: 'visible',
	width: '676px',
	height: '676px',
	maxWidth: '95%',
	top: '0',
	left: '0',
	right: '0',
};
export const closeSweetAlertStyle = {
	width: '20px',
	height: '20px',
	margin: '-20px -10px 0 0',
	padding: '0',
};

export const sweetAlertHeaderStyle = {
	color: 'black',
	textAlign: 'left',
	transform: 'translateY(-15px)',
};

export const loaderStyle = {
	display: 'flex',
	justifyContent: 'center',
	height: '53px',
	marginBottom: '11px',
};

export const loaderStyleEmptyCard = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '100px',
};

export const parseMapBoundaries = (mapObjectsBoundaries) => {
	// Split by objects
	const mapObjs = mapObjectsBoundaries ? mapObjectsBoundaries.split(';') : [];
	const boundaries = [];
	let currentPolygon = [];

	mapObjs.forEach((mo) => {
		// Remove ( and )
		mo = mo.replace(/[()]/g, '');
		// split string using comma
		const mo1 = mo.split(',');
		let currentVertex = [];
		//iterate
		mo1.forEach((el, i) => {
			currentVertex.push(parseInt(el, 10));
			//push current vertex to current polygon and reset current vertex:
			if (i % 2 !== 0) {
				currentPolygon.push(currentVertex);
				currentVertex = [];
			}
			//push current polygon to boundaries and reset current polygon:
			if (i === mo1.length - 1) {
				boundaries.push(currentPolygon);
				currentPolygon = [];
			}
		});
	});
	return boundaries;
};
